import axios from 'axios'

export default {
  api: axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json"
    }
  }),
}